// App bar (DESIGN.md 7): slim, single line, 56px mobile / 64px desktop.
// Left: brand monogram + title. Right: contextual indicator or demo badge.

import { BrandMark } from './BrandMark';
import { isDemoMode } from '../lib/api';

interface Props {
  title: string;
  context?: string;
  onBack?: () => void;
  backLabel?: string;
  trailing?: React.ReactNode;
}

import { ArrowLeft } from '../lib/icons';

export function AppBar({ title, context, onBack, backLabel = '返回', trailing }: Props) {
  return (
    <header className="appbar" role="banner">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: 0, flex: '1 1 auto' }}>
        {onBack && (
          <button
            type="button"
            className="btn btn-icon"
            aria-label={backLabel}
            onClick={onBack}
          >
            <ArrowLeft weight="regular" aria-hidden="true" />
          </button>
        )}
        {!onBack && <BrandMark size={24} className="text-accent" />}
        <span className="appbar-title">{title}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flex: '0 0 auto' }}>
        {context && <span className="appbar-context">{context}</span>}
        {isDemoMode() && (
          <span
            className="badge"
            style={{ background: 'var(--warning-soft)', color: 'var(--warning)', height: 22, fontSize: '0.6875rem' }}
            title="本机演示环境，使用合成数据，不连接真实后端"
          >
            演示数据
          </span>
        )}
        {trailing}
      </div>
    </header>
  );
}
